import React from 'react';
import PropTypes from 'prop-types';
//import "react-table/react-table.css";
import EditableGrid2 from "./EditableGrid2";

class UploadPageGrid extends React.PureComponent {
    constructor(props) {
      super(props);
      this.grid = React.createRef();

      this._handleBasicValueChange = this._handleBasicValueChange.bind(this);
      this._cellClassName = this._cellClassName.bind(this);
      this._tooltipGetter = this._tooltipGetter.bind(this);
    }

    _handleBasicValueChange({ rowData, column, value }) {
      if (column.type === "number") {
        value = 1* value;
      }
      this.props.onTransactionUpdate(rowData, { [column.dataKey]: value});
    }

    // eslint-disable-next-line no-unused-vars
    _cellClassName({ cellData, columns, column, columnIndex, rowData, rowIndex }) {
      return column.dataKey === "amount" && rowData.invalidSum? console.log(arguments) || "row-invalid" : null;
    }

    // eslint-disable-next-line no-unused-vars
    _tooltipGetter({ column, cellData, rowIndex, columnIndex, rowData }) {
      return column.dataKey === "amount" && rowData.invalidSum? rowData.invalidSum: null;
    }

    render() {

      const columns = [{
        key: 'description',
        dataKey: 'description',
        title: 'Description',
        width: 600,
        resizable: true,
        type: "string",
        onValueChange: this._handleBasicValueChange
      },{
        key: 'date',
        dataKey: 'date',
        title: 'Date',
        width: 120,
        resizable: true,
        type: "date",
        onValueChange: this._handleBasicValueChange
      },{
        key: 'category',
        dataKey: 'category',
        title: 'Category',
        width: 120,
        resizable: true,
        type: "dropdown",
        lov: this.props.transactionSplits,
        onValueChange: this._handleBasicValueChange
      },{
        key: 'amount',
        dataKey: 'amount',
        title: 'Amount',
        width: 90,
        resizable: true,
        type: "number",
        onValueChange: this._handleBasicValueChange,
        className: this._cellClassName,
        tooltipGetter: this._tooltipGetter
      },{
        key: 'status',
        dataKey: 'status',
        title: 'Status',
        width: 90,
        resizable: true,
        type: "string",
        //onValueChange: this._handleBasicValueChange,
        className: this._cellClassName,
        tooltipGetter: this._tooltipGetter
      }];

      return (
        <EditableGrid2
          columns={columns}
          data={this.props.pendingTransactions}
          onNewRowClick={this.props.onNewRowClick}
          onSelectionChange={this.props.onSelectionChange}
          selectionStorage={this.props.selectionStorage}
          noDataText="No record found yet. Start using the application by importing a CSV file."
          menuId={this.props.menuId}
        />

      );

    }
}

UploadPageGrid.propTypes = {
  pendingTransactions: PropTypes.array.isRequired,
  transactionSplits: PropTypes.array.isRequired,
  version: PropTypes.number.isRequired,
  onTransactionUpdate: PropTypes.func.isRequired,
  onNewRowClick: PropTypes.func.isRequired,
  onSelectionChange: PropTypes.func,
  selectionStorage: PropTypes.object,
  menuId: PropTypes.string
}

export default UploadPageGrid;